module.exports = __webpack_public_path__ + "static/media/img_01.9dd62ecc.png";